import { render, staticRenderFns } from "./SsoHandleToken.vue?vue&type=template&id=8229f660&scoped=true"
import script from "./SsoHandleToken.vue?vue&type=script&lang=js"
export * from "./SsoHandleToken.vue?vue&type=script&lang=js"
import style0 from "./SsoHandleToken.vue?vue&type=style&index=0&id=8229f660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1__ejs@3.1._d122e8da27108b932c0dfa09e6e9a5ee/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8229f660",
  null
  
)

export default component.exports